export { default as ExtraCampaignGateway } from './ExtraCampaignGateway'
export { default as ExtraCampaignService } from './ExtraCampaignService'
export { default as ExtraCampaignsServiceProvider } from './ExtraCampaignsServiceProvider'



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/index.js